import { render } from "./StatementOfActivity.vue?vue&type=template&id=99895dda&scoped=true"
import script from "./StatementOfActivity.vue?vue&type=script&lang=js"
export * from "./StatementOfActivity.vue?vue&type=script&lang=js"

import "./StatementOfActivity.vue?vue&type=style&index=0&id=99895dda&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99895dda"]])

export default __exports__